import { createRoot } from 'react-dom/client';
import { AccountWidgetIsland } from '@scripts/islands/account-widget/index.jsx';
import { MiniCartIsland } from '@scripts/islands/mini-cart/index.jsx';
import { ProductFiltersIsland } from '@scripts/islands/product-filters/index.jsx';
import { VariationSelectorIsland } from '@scripts/islands/variation-selector/index.jsx';

const registry = {
  'account-widget': AccountWidgetIsland,
  'mini-cart': MiniCartIsland,
  'product-filters': ProductFiltersIsland,
  'variation-selector': VariationSelectorIsland,
};

function parseProps(node) {
  const rawProps = node.getAttribute('data-props');

  if (!rawProps) {
    return {};
  }

  try {
    return JSON.parse(rawProps);
  } catch (error) {
    // Keep the mount resilient so one broken payload does not block the page.
    console.warn('Failed to parse island props.', error);
    return {};
  }
}

function mountIslandNode(node) {
  const islandName = node.getAttribute('data-island');

  if (!islandName || !registry[islandName] || node.dataset.islandMounted === 'true') {
    return;
  }

  const IslandComponent = registry[islandName];
  const props = parseProps(node);
  const root = createRoot(node);

  root.render(<IslandComponent {...props} />);
  node.__healthProductIslandRoot = root;
  node.dataset.islandMounted = 'true';
}

export function mountIslands(scope = document) {
  const nodes =
    scope instanceof Element && scope.matches('[data-island]')
      ? [scope, ...scope.querySelectorAll('[data-island]')]
      : scope.querySelectorAll('[data-island]');

  nodes.forEach((node) => {
    mountIslandNode(node);
  });
}

export function observeIslands() {
  if (typeof MutationObserver === 'undefined') {
    return null;
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) {
          return;
        }

        mountIslands(node);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  return observer;
}
